export default "__VITE_ASSET__BcdhdWwk__"